import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useGetCompanyQuery } from '@blockpulse3/graphql/hooks';
import { useUser } from '@blockpulse3/web-client/auth';

/**
 * useIdentityId.
 * Return identity id associated to current workspace; user or company.
 *
 * @returns {string | null}
 */
export function useIdentityId(): string | null {
  const { user } = useUser();
  const { companyId = '' } = useParams();
  const companyReq = useGetCompanyQuery({
    variables: { companyId },
    skip: !companyId,
  });
  const company = companyReq?.data?.company;

  const identityId = useMemo(() => {
    if (companyId && company) {
      return company.identity?.id;
    }
    if (user) {
      return user.individualIdentity?.identity?.id;
    }
    return null;
  }, [companyId, company, user]);

  return identityId || null;
}
